import React, {Component} from "react";
import { URL,USER } from "../../constants/constant";
import {_axios} from '../../plugins/axios';
import ToasterComponent from "../common/toaster";

class CallCustomer extends Component{
  constructor(props){
    super(props);
    this.state = {
        user : USER.user,
        showSnackbar : false,
        messageSnacks : '',
    }
  }

toastComponent(){
  return <ToasterComponent show={this.state.showSnackbar ? this.state.showSnackbar : ''} message={this.state.messageSnacks ? this.state.messageSnacks : ''}></ToasterComponent>;
}

  callCustomer(){

    const that = this;
    let url = URL.dev_url;
     let route = url + 'callConnect'

     let obj = {
      to : localStorage.getItem('customer_phoneNumber') ? JSON.parse(localStorage.getItem('customer_phoneNumber')).toString(): '',
      from : this.state.user.phonenumber1
    }
    console.log("call",obj)

    _axios.post(route,obj)
    .then(function (response) {
        if(response.data.success){
            that.setState({
              messageSnacks : "Call Initiated",
              showSnackbar : true,
          },()=>{
              that.toastComponent();
          })
        }else{
              that.setState({
                messageSnacks : "Call Failed",
                showSnackbar : true,
            },()=>{
                that.toastComponent();
            })
        }
    }).catch(function (error) {
        console.log(error);
    })

  }

  render(){
    return(
        <div className="call-icon-bg">
          <i className="fa fa-phone" aria-hidden="true" onClick={()=> this.callCustomer()}></i>
        </div>
        )    
      }
}
export default CallCustomer;